import InnerComponent from '@Components/Inventory/Indent/UpdateIndent';
import orgContainer from '@Components/AppContainer';

const UpdateIndent = () => ((orgContainer(InnerComponent)));
export default UpdateIndent;
